module.exports = __webpack_public_path__ + "img/banner_1.edcf0b9e.jpg";